import DENTModalOverviewGeneralButtons from './DENTModalOverviewGeneralButtons';
import React, { useEffect, useMemo, useState } from 'react';
import { ToothDetailContentType } from '../../Enums/ToothDetailContentType.enum';
import styles from './DENTModalOverviewGeneral.module.scss';
import DENTModalOverviewGeneralTreatments from '../DENTModalOverviewGeneralTreatments/DENTModalOverviewGeneralTreatments';
import DENTModalOverviewGeneralEndodontic from '../DENTModalOverviewGeneralEndodontic/DENTModalOverviewGeneralEndodontic';
import DENTModalOverviewGeneralPeriodontal from '../DENTModalOverviewGeneralPeriodontal/DENTModalOverviewGeneralPeriodontal';
import { useDENTContext } from '../../Services/DENTContext';
import DENTModalOverviewGeneralEndodonticTemperature from '../DENTModalOverviewGeneralEndodontic/DENTModalOverviewGeneralEndodonticTemperature';
import DENTModalOverviewGeneralEndodonticTest from '../DENTModalOverviewGeneralEndodontic/DENTModalOverviewGeneralEndodonticPain';
import DENTModalOverviewGeneralEndodonticElectricity from '../DENTModalOverviewGeneralEndodontic/DENTModalOverviewGeneralEndodonticElectricity';
import { EndodonticButtonOption } from '../../Helpers/endodontic/endodonticButtonOptions';

interface Props {
	onChangeContentType: (type: ToothDetailContentType) => void;
	onClose: () => void;
}

const DENTModalOverviewGeneral = ({ onChangeContentType, onClose }: Props) => {
	const { activeTooth } = useDENTContext();
	const [selectedTest, setSelectedTest] =
		useState<EndodonticButtonOption['value']>();

	const setToPeriodontalContent = () => {
		setSelectedTest(undefined);
	};

	const selectedComponent = useMemo(() => {
		switch (selectedTest) {
			case 'cold':
			case 'heat':
				return (
					<DENTModalOverviewGeneralEndodonticTemperature
						type={selectedTest}
						onClose={setToPeriodontalContent}
					/>
				);
			case 'electric':
				return (
					<DENTModalOverviewGeneralEndodonticElectricity
						onClose={setToPeriodontalContent}
					/>
				);
			case 'percussion':
			case 'palpation':
				return (
					<DENTModalOverviewGeneralEndodonticTest
						type={selectedTest}
						onClose={setToPeriodontalContent}
					/>
				);
			default:
				return (
					<DENTModalOverviewGeneralPeriodontal
						onChangeContentType={onChangeContentType}
					/>
				);
		}
	}, [selectedTest, activeTooth]);

	return (
		<div className={styles.wrapper}>
			<DENTModalOverviewGeneralButtons
				onChangeContentType={onChangeContentType}
				onClose={onClose}
			/>
			{/*<DENTModalOverviewGeneralTreatments /> - TODO: remove after treatments are done*/}
			<div className={styles.sections}>
				<DENTModalOverviewGeneralEndodontic selectTest={setSelectedTest} />
				{selectedComponent}
			</div>
		</div>
	);
};

export default DENTModalOverviewGeneral;
